
import React from 'react';

export const BannerSection: React.FC = () => {
  return (
    <section className="relative h-96 flex items-center justify-center overflow-hidden">
      <div
        className="absolute inset-0 bg-cover bg-center bg-no-repeat"
        style={{
          backgroundImage: `url('/banners/hero-about.jpg')`
        }}
      />
      <div className="absolute inset-0 bg-black/40" />

      <div className="relative z-10 text-center text-white max-w-4xl mx-auto px-6">
        <h1 className="text-5xl md:text-6xl font-bold mb-6">About Us</h1>
        <p className="text-xl md:text-2xl font-light max-w-2xl mx-auto">
          Crafting extraordinary travel experiences across generations for over 13 years
        </p>
      </div>
    </section>
  );
};
